import { Helmet } from "react-helmet-async";

/**
 * Conditionally injects analytics scripts only when env vars are set.
 * - GA4: set VITE_GA_ID (e.g. G-XXXXXXX)
 * - Yandex.Metrika: set VITE_YM_ID (numeric counter id)
 */
const Analytics = () => {
  const gaId = import.meta.env.VITE_GA_ID as string | undefined;
  const ymId = import.meta.env.VITE_YM_ID as string | undefined;

  return (
    <Helmet>
      {gaId && (
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        />
      )}
      {gaId && (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}', { anonymize_ip: true });
        `}</script>
      )}
      {ymId && (
        <script>{`
          (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();for(var j=0;j<document.scripts.length;j++){if(document.scripts[j].src===r){return;}}
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
          (window,document,'script','https://mc.yandex.ru/metrika/tag.js','ym');
          ym(${ymId},'init',{clickmap:true,trackLinks:true,accurateTrackBounce:true,webvisor:true});
        `}</script>
      )}
    </Helmet>
  );
};

export default Analytics;
